import { render, staticRenderFns } from "./RightAside.vue?vue&type=template&id=6a2559ee&scoped=true"
import script from "./RightAside.vue?vue&type=script&lang=js"
export * from "./RightAside.vue?vue&type=script&lang=js"
import style0 from "./RightAside.vue?vue&type=style&index=0&id=6a2559ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2559ee",
  null
  
)

export default component.exports